export const SEARCH_FLIGHTS_TEXT = "Search Flights";
export const CHOOSE_DATES = "Choose Dates";
export const OUTBOUND = "Outbound";
export const RETURN = "Return";
export const UPDATE_CALENDAR_TEXT = "Updating your calendar";
